
import { Mixins, Component, Prop } from 'vue-property-decorator'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import { PageInfo } from '@/schema'
import { projectClient } from '@/apolloClient'
import { PROJECT_LOCATION_DRAWINGS_QUERY } from '@/views/Project/gql/queries'
import RichTextField from '@/components/RichTextField/richTextField.vue'
import LocationDrawing from '../components/locationDrawing.vue'
import { getPreview } from '@/utils/attachment'
import VImageWrapper from '@/components/imageWrapper.vue'
@Component({
    name: 'LocationDrawingDialog',
    components: { DialogTemplate, RichTextField, LocationDrawing, VImageWrapper },
})
export default class LocationDrawingDialog extends Mixins() {
    @Prop() props!: any
    getPreview = getPreview

    get observation() {
        return this.props.observation
    }

    get projectId() {
        return this.props.projectId
    }

    get disabled() {
        return this.props.disabled
    }

    get devicePixelRatio() {
        return window.devicePixelRatio || 1
    }
    // Infinit loading
    infiniteId = crypto['randomUUID']()
    isReady = false //required to correctly initiate inifite loading
    pageInfo = null as Maybe<PageInfo>
    locationDrawings: Array<any> = []
    errorLocationDrawing = false

    forceLoadingLocationDrawings() {
        this.errorLocationDrawing = false
        this.infiniteId = crypto['randomUUID']()
    }

    async searchLocationDrawings($state: any) {
        try {
            const variables = {
                projectId: this.projectId,
                isArchived: false,
                after: this.pageInfo?.endCursor || null,
            }

            const { data: locationDrawingsResult } = await projectClient.query({
                query: PROJECT_LOCATION_DRAWINGS_QUERY,
                variables,
                fetchPolicy: 'network-only',
            })
            this.locationDrawings = this.locationDrawings.concat(
                locationDrawingsResult?.locationDrawings?.nodes || []
            )

            this.pageInfo = locationDrawingsResult.locationDrawings.pageInfo || null

            if (this.pageInfo?.hasNextPage === false) {
                $state.complete()
            } else {
                $state.loaded()
            }
        } catch (error) {
            this.errorLocationDrawing = true
            console.log('searchLocationDrawings', error)
            $state.complete()
        }
    }

    // Location drawing select
    locationDrawingObj = {
        locationDrawing: {
            data: null as null | Record<string, any>,
        },
        locationDrawingX: null as null | number,
        locationDrawingY: null as null | number,
    }

    get isValid() {
        const { data } = this.locationDrawingObj.locationDrawing
        const { locationDrawingX, locationDrawingY } = this.locationDrawingObj
        return !!data === (locationDrawingX !== null && locationDrawingY !== null)
    }

    initLocationDrawing() {
        Object.keys(this.locationDrawingObj).forEach((key) => {
            this.locationDrawingObj[key] = this.observation[key]
        })
    }

    selectLocationDrawing(locationDrawing) {
        if (this.disabled) return
        this.locationDrawingObj.locationDrawing = {
            data: locationDrawing
                ? {
                      ...locationDrawing,
                      fileId: locationDrawing.file,
                  }
                : null,
        }

        this.locationDrawingObj.locationDrawingX = null
        this.locationDrawingObj.locationDrawingY = null
    }

    submitResponse(confirm: boolean) {
        if (confirm) {
            this.$emit('close', this.locationDrawingObj)
        } else {
            this.$emit('close', false)
        }
    }

    mounted() {
        this.isReady = false
        this.initLocationDrawing()
        this.isReady = true
    }
}
